export const SketchOrderStatusId = {
    Cancelled: 1,
    Complete: 2,
    InProgress: 3,
    Incomplete: 4,
    Pending: 5, // Means 'not started by sketch tech'
    PendingReview: 6, // Means 'pending review by sketchos admin'
    Billed: 7,
    PendingRejection: 8,
    Queued: 9,
    Exception: 10,
    BillingFailed: 11,
    InReview: 12,
    RevisionRequested: 13,
    PendingGroupBilling: 14,
};

export const SketchOrderStatus = {
    Cancelled: 'Cancelled',
    Complete: 'Complete',
    InProgress: 'InProgress',
    Incomplete: 'Incomplete',
    Pending: 'Pending', // Means 'not started by sketch tech'
    PendingReview: 'PendingReview',
    Billed: 'Billed',
    PendingRejection: 'PendingRejection',
    Queued: 'Queued',
    Exception: 'Exception',
    BillingFailed: 'BillingFailed',
    InReview: 'InReview',
    RevisionRequested: 'RevisionRequested',
    PendingGroupBilling: 'PendingGroupBilling',
};

export type SketchOrderStatusType = $Keys<typeof SketchOrderStatus>;

export const allSketchOrderStatuses = [
    {
        id: SketchOrderStatusId.Pending,
        status: SketchOrderStatus.Pending,
    },
    {
        id: SketchOrderStatusId.Queued,
        status: SketchOrderStatus.Queued,
    },
    {
        id: SketchOrderStatusId.InProgress,
        status: SketchOrderStatus.InProgress,
    },
    {
        id: SketchOrderStatusId.PendingReview,
        status: SketchOrderStatus.PendingReview,
    },
    {
        id: SketchOrderStatusId.PendingRejection,
        status: SketchOrderStatus.PendingRejection
    },
    {
        id: SketchOrderStatusId.Complete,
        status: SketchOrderStatus.Complete,
    },
    {
        id: SketchOrderStatusId.Cancelled,
        status: SketchOrderStatus.Cancelled,
    },
    {
        id: SketchOrderStatusId.Incomplete,
        status: SketchOrderStatus.Incomplete,
    },
    {
        id: SketchOrderStatusId.Billed,
        status: SketchOrderStatus.Billed
    },
    {
        id: SketchOrderStatusId.Exception,
        status: SketchOrderStatus.Exception
    },
    {
        id: SketchOrderStatusId.BillingFailed,
        status: SketchOrderStatus.BillingFailed,
    },
    {
        id: SketchOrderStatusId.InReview,
        status: SketchOrderStatus.InReview,
    },
    {
        id: SketchOrderStatusId.RevisionRequested,
        status: SketchOrderStatus.RevisionRequested
    },
    {
        id: SketchOrderStatusId.PendingGroupBilling,
        status: SketchOrderStatus.PendingGroupBilling
    }
];
